import { render } from "./AboutTestsModal.vue?vue&type=template&id=775fda9a&scoped=true"
import script from "./AboutTestsModal.vue?vue&type=script&lang=js"
export * from "./AboutTestsModal.vue?vue&type=script&lang=js"

import "./AboutTestsModal.vue?vue&type=style&index=0&id=775fda9a&scoped=true&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-775fda9a"]])

export default __exports__